import { gql } from '@apollo/client';

export * from './integrationMemberRemove.mutation.generated';

export const INTEGRATION_MEMBER_REMOVE = gql`
  mutation integrationMemberRemove($id: ID!) {
    integrationMemberRemove(input: { integrationMemberId: $id }) {
      success
      errors
    }
  }
`;
